import { useNavigate, useSearch } from "@tanstack/react-router";

import { Button } from "@/components/ui/button";

import { CostsLogPane } from "./CostsLogPane";
import { LOGS_COPY, PANES, paramsFrom, searchForPane, type LogPane } from "./logs";
import { PriceLogPane } from "./PriceLogPane";
import { RrpExceptionsPane } from "./RrpExceptionsPane";

/** The Logs tab: three panes as a segmented control, Costs, Price and RRP exceptions (the last live from C1 v1.6, unit 14). */
export function LogsTab({ areaName }: { areaName: string }) {
  const search = useSearch({ strict: false }) as Record<string, unknown>;
  const navigate = useNavigate();
  const pane: LogPane = paramsFrom(search).pane;
  const go = (next: LogPane) => void navigate({ to: ".", search: searchForPane(search, next), replace: true });
  return (
    <div className="flex flex-col gap-3">
      <div role="group" aria-label="Pane" className="flex gap-1">
        {PANES.map((key) => (
          <Button key={key} size="sm" variant={key === pane ? "default" : "outline"} aria-pressed={key === pane} data-nonmutating onClick={() => go(key)}>
            {LOGS_COPY.panes[key]}
          </Button>
        ))}
      </div>
      {pane === "costs" && <CostsLogPane areaName={areaName} />}
      {pane === "price" && <PriceLogPane areaName={areaName} />}
      {pane === "rrp" && <RrpExceptionsPane areaName={areaName} />}
    </div>
  );
}
